import { EditorContent, useEditor } from "@tiptap/react";
import { Box, IconButton } from "@mui/material";
import { useEffect } from "react";
import { composeEditorExtensions } from "../tiptapExtensions";

import FormatBoldIcon from "@mui/icons-material/FormatBold";
import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import FormatUnderlinedIcon from "@mui/icons-material/FormatUnderlined";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import InsertLinkIcon from "@mui/icons-material/InsertLink";

export default function TipTapEditorNew({ value, onChange }) {
  const editor = useEditor({
    content: value || "",
    extensions: composeEditorExtensions,
    onUpdate({ editor }) {
      if (onChange) onChange(editor.getHTML());
    },
  });

  // Cuando value cambie, montamos una vez y lo bloqueamos
  useEffect(() => {
    if (!editor) return;

    const current = editor.getHTML();

    if (value && value !== current) {
      editor.commands.setContent(value, false);
    }
  }, [value, editor]);

  if (!editor) return null;

  const addLink = () => {
    const url = prompt("Introduce URL:");
    if (!url) return;
    editor.chain().focus().extendMarkRange("link").setLink({ href: url }).run();
  };

  return (
    <Box>
      <Box sx={{ display: "flex", gap: 1, background: "#f5f5f7", p: 1 }}>
        <IconButton onClick={() => editor.chain().focus().toggleBold().run()}>
          <FormatBoldIcon />
        </IconButton>
        <IconButton onClick={() => editor.chain().focus().toggleItalic().run()}>
          <FormatItalicIcon />
        </IconButton>
        <IconButton
          onClick={() => editor.chain().focus().toggleUnderline().run()}
        >
          <FormatUnderlinedIcon />
        </IconButton>
        <IconButton
          onClick={() => editor.chain().focus().toggleBulletList().run()}
        >
          <FormatListBulletedIcon />
        </IconButton>
        <IconButton onClick={addLink}>
          <InsertLinkIcon />
        </IconButton>
      </Box>

      <Box
        sx={{
          border: "1px solid #ddd",
          p: 2,
          background: "white",
          minHeight: 200,
        }}
      >
        <EditorContent editor={editor} />
      </Box>
    </Box>
  );
}
